/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 19:17:06
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {CompareNoticeDOI} from "./api/compareNoticeApi";
import CompareNoticeService from "./service/compareNoticeService";
import './compareNotice.less';

@Component({name: 'compare-notice'})
export default class CompareNotice extends BasicSearchPage<CompareNoticeService, CompareNoticeDOI.RowDataI, CompareNoticeDOI.QueryRowDataParamsI> {

    checkBoxShow = true
    
    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new CompareNoticeService(this)
	}
}